<div class="w-screen sm:max-h-100 sm:max-w-2xl md:max-h-130 md:max-w-3xl lg:max-h-158 lg:max-w-4xl">
  <div class="space-y-2.5">
    @if ((isQuarterCloseEnabled$ | async) === false) {
      <div>Before you close, please confirm:</div>

      @for (step of steps; track step; let i = $index) {
        <div class="flex items-center">
          <div
            class="mr-2.5 flex h-6 w-6 items-center justify-center rounded-full border bg-aux-gray-light"
          >
            {{ i + 1 }}
          </div>
          <div>{{ step }}</div>
        </div>
      }
    }

    <aux-close-month-audit-package-confirmation></aux-close-month-audit-package-confirmation>

    <div>
      Closing the month will convert your expense estimates to actuals and generate your audit
      support package. Please note this action is permanent. Closed months cannot be reopened and
      data in closed months cannot be updated. Please add a note and continue.
    </div>

    <aux-input
      label="Note"
      class="text-xs"
      [textArea]="true"
      [rows]="2"
      [validators]="'required'"
      [formControl]="textarea"
      [showRequiredAsterisk]="true"
      resize="none"
    />

    @if ((showNetsuiteMessage$ | async) === true) {
      <div style="padding-top: 15px; padding-bottom: 15px">
        <div
          style="
            border-top: 0.5px solid var(--aux-gray-dark-100);
            border-bottom: 0.5px solid var(--aux-gray-dark-100);
          "
        >
          <aux-checkbox class="mb-3 mt-3 text-sm" [formControl]="sendToNetsuite">
            Create Journal Entry in NetSuite General Ledger
          </aux-checkbox>
        </div>
      </div>
    }
  </div>
</div>
